import React from 'react';
import PropTypes from 'prop-types';
import './tile.scss';


const Tile = ({
    programId,
    assetId,
    backgroundImage,
    ctaUrl,
}) => {
    const getImageUrl = imageObj => (
        imageObj ? imageObj.url : null
    );

    const cardId = `card-${programId}`;
    const tileUrl = (ctaUrl && ctaUrl.length) ? ctaUrl : `/asset/id/${assetId}/?view_type=primary`;
    const backgroundImageStyles = {
        backgroundImage: `url(${getImageUrl(backgroundImage)})`,
    };

    return (
        <div className="tile-content">
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 hc-card" id={cardId}>
                <div className="card hc-bg-color-9" style={backgroundImageStyles}>
                    <a className="ed_link full-szie-link" href="#" ed_path={tileUrl} program_id={programId} fk_adid="0" num_views="0" viewd_count="0">&nbsp;</a>
                </div>
            </div>
        </div>
    );
};

Tile.propTypes = {
    programId: PropTypes.string,
    assetId: PropTypes.string,
    backgroundImage: PropTypes.shape({
        url: PropTypes.string,
    }),
    ctaUrl: PropTypes.string,
};

Tile.defaultProps = {
    programId: null,
    assetId: null,
    ctaUrl: null,
    backgroundImage: {},
};

export default Tile;
